export enum MediaTypes {
  Img = 'Image',
  Audio = 'Audio',
  Video = 'Video',
}

export enum MediaTypeKeys {
  Img = 'image',
  Audio = 'audio',
  Video = 'video',
}

export const MediaTypeExtensions = new Map<MediaTypes, string[]>([
  [MediaTypes.Img, ['jpg', 'jpeg', 'png', 'gif', 'svg']],
  [MediaTypes.Audio, ['mp3', 'wav', 'ogg']],
  [MediaTypes.Video, ['mp4', 'webm', 'ogg']],
]);

export const MediaTypeIcons = new Map<MediaTypes, string>([
  [MediaTypes.Img, 'photo'],
  [MediaTypes.Audio, 'notes'],
  [MediaTypes.Video, 'film'],
]);
